/*
 * porcao:update
 */

$('body').on('change', '.list-complete-menu [name=porcao_id]', function() {
	var $self = $(this);
	var $form = $self.closest('form');
	var $option = $self.find(':selected');
	
	var $price = $form.find('.price');
	var $quantidade = $form.find('[name=quantidade]');
	var $boxQuantidade = $quantidade.closest('.component-qtd');

	var estoque = $option.data('estoque')|0;
	var promocao = $option.data('promocao')|0;
	var valor = $option.data('valor')*1.0;
	var valor_promocional = $option.data('valor_promocional')*1.0;

	if (promocao && valor_promocional > 0.0) {
		valor = valor_promocional;
	}
	
	$price.html('R$ '+(valor.number_format(2,',','.')));

	var quantidade = $quantidade.val();
	if (quantidade > estoque) {		 		
		$quantidade.val(estoque);
	}

	$boxQuantidade.data('max',estoque);
});

$('.list-complete-menu [name=porcao_id]').trigger('change');

 /*
  * add carrinho
  */

$('body').on('submit', '.list-complete-menu form', function() {
	try	{
		var $self = $(this);
		if ($self.data('enviando')) return;

		$.fancybox.showLoading();
		$self.data('enviando',true);

		var callback = function(resp) {
			$.fancybox.hideLoading();
			$self.data('enviando',false);

			if (resp.success) {
				swal(
				  'Produto adicionado ao carrinho com sucesso!',
				  'Para continuar comprando clique em "Ok" ou <a href="carrinho">clique aqui</a> para finalizar!',
				  'success'
				).catch(swal.noop);
			} else {
				swal(
				  'Oops...',
				  'Não foi possível adicionar o produto ao carrinho!',
				  'error'
				)
			}
		};

		$.ajax({
			url: $self.attr('action'),
			type: 'post',
			dataType: 'json',
			data: $self.serialize(),
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível adicionar ao carrinho."
				});
			}
		});

	} catch (e) {
		console.log(e);
	}

	return false;
});


//////////////////
// WEBPACK FOOTER
// ../src/cardapio-completo/index.js
// module id = 64
// module chunks = 0